import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import DateFnsUtils from '@date-io/date-fns'

import { serverUrl, headerRequest } from '../../lib/funApp/general'

import { Card, Col, Container, Row } from 'react-bootstrap'
import { Button, Icon, Table } from 'semantic-ui-react'
import { MDBIcon } from 'mdbreact'
import { FormControl, Grid, InputLabel, ListSubheader, MenuItem, Select } from '@material-ui/core'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'

export default class ReportsCategory extends Component {
  constructor() {
    super()
    this.state = {
      dateIni: moment().startOf('month').toDate(),
      dateEnd: moment().endOf('month').toDate(),
      categoryFilter: '',
      dataCategory: [],
      dataRecords: [],
      isLoading: false,
      isDisabled: false,
      total: 0,
    }
  }

  componentDidMount() {
    this.getCategories()
  }

  changeDateIni = (value) => {
    this.setState({ dateIni: value })
  }

  changeDateEnd = (value) => {
    this.setState({ dateEnd: value })
  }

  changeCategoryFilter = (value) => {
    this.setState({ categoryFilter: value })
  }

  getCategories = () => {
    axios
      .get(serverUrl + '/src/categories', { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        const firstCategoryId = items.length > 0 ? items[0]._id : ''
        this.setState({ dataCategory: items, categoryFilter: firstCategoryId }, () => {
          this.getRecords()
        })
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  getPersonName = (record) => {
    if (!record || !record.person) return '-'
    if (typeof record.person === 'object') return record.person.name || '-'
    return '-'
  }

  getCategoryLabel = (record) => {
    const categories = Array.isArray(record && record.category) ? record.category : []
    if (categories.length === 0) return '-'
    if (categories.length > 1) return 'Diversas'
    const categoryRef = categories[0] && categories[0].category
    if (!categoryRef) return '-'
    if (typeof categoryRef === 'object') return categoryRef.name || '-'
    const found = this.state.dataCategory.find((item) => item && String(item._id) === String(categoryRef))
    return found && found.name ? found.name : '-'
  }

  getRecords = () => {
    this.setState({ isLoading: true, isDisabled: true })

    const targetUrl =
      serverUrl +
      '/src/records?dtstart=' +
      moment(this.state.dateIni).format('YYYY-MM-DD') +
      '&dtend=' +
      moment(this.state.dateEnd).format('YYYY-MM-DD') +
      '&prevision=exclude'

    axios
      .get(targetUrl, { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        const filtered = items.filter((record) => {
          if (!record || !this.state.categoryFilter) return false
          const categories = Array.isArray(record.category) ? record.category : []
          return categories.some((entry) => {
            const categoryRef = entry && entry.category
            const categoryId = categoryRef && typeof categoryRef === 'object' ? categoryRef._id : categoryRef
            return String(categoryId) === String(this.state.categoryFilter)
          })
        })

        const sorted = filtered.sort((a, b) => {
          const dateA = new Date(a && a.date ? a.date : 0).getTime()
          const dateB = new Date(b && b.date ? b.date : 0).getTime()
          return dateA - dateB
        })
        const total = sorted.reduce(
          (sum, record) => sum + Math.abs(Number(record && record.value ? record.value : 0)),
          0
        )
        this.setState({ dataRecords: sorted, total, isLoading: false, isDisabled: false })
      })
      .catch((error) => {
        console.log(error.response || error)
        this.setState({ dataRecords: [], total: 0, isLoading: false, isDisabled: false })
      })
  }

  render() {
    return (
      <>
        <Container>
          <Row className="TitleContainer">
            <Col style={{ padding: '10px' }}>
              <h4>
                <MDBIcon icon="file-invoice" className="mr-2 ml-4" />
                Relatórios - Por Categoria
              </h4>
            </Col>
          </Row>
        </Container>

        <Container className="MainContainer" style={{ backgroundColor: 'white', padding: '5px' }}>
          <Row className="mb-3">
            <Col>
              <Card>
                <Card.Body>
                  <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
                    <Grid item xs={12} md={4}>
                      <FormControl controlid="dateStart">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-start-report-category"
                            label="Início"
                            value={this.state.dateIni}
                            onChange={(e) => this.changeDateIni(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                      <FormControl controlid="dateEnd" className="ml-3">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-end-report-category"
                            label="Fim"
                            value={this.state.dateEnd}
                            onChange={(e) => this.changeDateEnd(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl className="w-100">
                        <InputLabel id="report-category-filter">Categoria</InputLabel>
                        <Select
                          labelId="report-category-filter"
                          id="report-category-select"
                          value={this.state.categoryFilter}
                          onChange={(e) => this.changeCategoryFilter(e.target.value)}
                        >
                          <ListSubheader>Receitas</ListSubheader>
                          {this.state.dataCategory
                            .filter((item) => item && item.type === 'R')
                            .map((item) => (
                              <MenuItem key={item._id} value={item._id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          <ListSubheader>Despesas</ListSubheader>
                          {this.state.dataCategory
                            .filter((item) => item && item.type === 'D')
                            .map((item) => (
                              <MenuItem key={item._id} value={item._id}>
                                {item.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4} className="text-right">
                      <Button
                        icon
                        labelPosition="left"
                        color={!this.state.isLoading ? 'blue' : 'grey'}
                        disabled={this.state.isDisabled}
                        onClick={this.getRecords}
                      >
                        {!this.state.isLoading ? 'Atualizar' : 'Aguarde'}
                        <Icon name="sync" loading={this.state.isLoading} />
                      </Button>
                    </Grid>
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className="text-right mb-2">
                    <strong>Total: </strong>
                    <CurrencyFormat
                      value={this.state.total}
                      displayType={'text'}
                      thousandSeparator="."
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale={2}
                      prefix="R$ "
                    />
                  </div>
                  <Table fixed compact celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '130px' }}>Data</Table.HeaderCell>
                        <Table.HeaderCell>Pessoa</Table.HeaderCell>
                        <Table.HeaderCell>Categoria</Table.HeaderCell>
                        <Table.HeaderCell>Histórico</Table.HeaderCell>
                        <Table.HeaderCell className="text-right" style={{ width: '180px' }}>
                          Valor
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {this.state.dataRecords.length > 0 ? (
                        this.state.dataRecords.map((record) => (
                          <Table.Row key={record._id}>
                            <Table.Cell>{moment(record.date).format('DD/MM/YYYY')}</Table.Cell>
                            <Table.Cell>{this.getPersonName(record)}</Table.Cell>
                            <Table.Cell>{this.getCategoryLabel(record)}</Table.Cell>
                            <Table.Cell>{record.history || '-'}</Table.Cell>
                            <Table.Cell className="text-right">
                              <CurrencyFormat
                                value={Math.abs(Number(record.value || 0))}
                                displayType={'text'}
                                thousandSeparator="."
                                decimalSeparator=","
                                fixedDecimalScale={true}
                                decimalScale={2}
                                prefix="R$ "
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      ) : (
                        <Table.Row>
                          <Table.Cell colSpan="5" className="text-center">
                            Nenhum registro encontrado para o filtro.
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
